export default __webpack_public_path__ + "static/media/close.4d8fdee5.svg";